import React, { FunctionComponent } from 'react';

import { Skeleton } from '@yandex-360/orb-components/dist/components/Skeleton';
import cn from 'classnames';
import { range } from 'lodash';

import { useIsOneColLayout } from '../../../../hooks';
import styles from './styles.css';

const REPEAT_PATTERN_COUNT = 4;
export const FullLoadingSkeleton: FunctionComponent = () => {
    const isOneColLayout = useIsOneColLayout();
    return (
        <div className={cn(styles.fullLoadingSkeleton, { [styles.oneColLayout]: isOneColLayout })}>
            {range(REPEAT_PATTERN_COUNT).map(() => {
                return (
                    <>
                        <Skeleton
                            width="var(--conferences-history-date-range-skeleton-width)"
                            height="var(--orb-size-16-m)"
                        />
                        <Skeleton width="100%" height="var(--orb-size-40-m)" />
                        <Skeleton width="100%" height="var(--orb-size-40-m)" />
                        <Skeleton width="100%" height="var(--orb-size-40-m)" />
                    </>
                );
            })}
        </div>
    );
};
